<template>
  <v-content>
    <v-container fluid>
      <h1>HPS Index</h1>
      <router-view name="hps" />
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: 'HPSIndex',
}
</script>
